import React from 'react'
import styled from 'styled-components'
import { UltraLight, Regular, MqTablet, MqDesktop, Mono } from 'streamr-ui/css/consts'
import useRealtimeDataTokenStream from '~hooks/useRealtimeDataTokenStream'
import formatMoney from '~utils/formatMoney'

const Name = styled.div`
    font-family: ${Mono};
    font-size: 0.625rem;
    font-weight: ${Regular};
    letter-spacing: 1.5px;
    line-height: 1.5rem;
    text-transform: uppercase;
    color: #adadad;
    white-space: nowrap;

    @media ${MqTablet} {
        font-size: 0.875rem;
    }
`

const Value = styled.div`
    font-size: 1.375rem;
    font-weight: ${UltraLight};
    line-height: 2.25rem;
    margin-top: 0;
    color: #0c009a;
    letter-spacing: -0.5px;
    white-space: nowrap;

    @media ${MqTablet} {
        margin-top: 0.5rem;
        font-size: 2rem;
    }

    @media ${MqDesktop} {
        font-size: 2.5rem;
    }
`

const Monetary = styled.div``

const Supply = styled.div``

const formatAmount = (amount) => {
    if (amount > 1000000000) {
        return `${Math.round(amount / 1000000000)}B`
    }

    if (amount > 1000000) {
        return `${Math.round(amount / 1000000)}M`
    }

    if (amount > 1000) {
        return `${Math.round(amount / 1000)}K`
    }

    return Math.round(amount / 1000)
}

const UnstyledAmounts = (props) => {
    const {
        DATAUSDPoint,
        DATAUSDVolumePoint,
        DATAUSDMarketCapPoint,
        circulatingSupply,
        totalSupply,
    } = useRealtimeDataTokenStream()

    return (
        <div {...props}>
            <Monetary $appearIntersection>
                <Name $appear>DATA/USD</Name>
                <Value $appear>
                    {formatMoney(Math.round(DATAUSDPoint * 10000) / 10000).replace(/\s+/g, ',')}
                </Value>
                <Name $appear>24H CEX VOLUME/USD</Name>
                <Value $appear>
                    {formatMoney(Math.round(DATAUSDVolumePoint)).replace(/\s+/g, ',')}
                </Value>
                <Name $appear>MARKET CAP/USD</Name>
                <Value $appear>
                    {formatMoney(Math.round(DATAUSDMarketCapPoint)).replace(/\s+/g, ',')}
                </Value>
            </Monetary>
            <Supply $appearIntersection>
                <Name $appear>TOTAL SUPPLY</Name>
                <Value $appear>{formatAmount(totalSupply)}</Value>
                <Name $appear>MAXIMUM SUPPLY</Name>
                <Value $appear>2B</Value>
                <Name $appear>CIRCULATING SUPPLY</Name>
                <Value $appear>{formatAmount(circulatingSupply)}</Value>
            </Supply>
        </div>
    )
}

const Amounts = styled(UnstyledAmounts)`
    display: flex;
    flex-direction: row;
    justify-content: center;

    ${Monetary} {
        flex: 1;
        margin-right: 1.5rem;
    }

    ${Value} + ${Name} {
        margin-top: 1.5rem;
    }

    ${Supply} {
        flex: 1;
        margin-top: 0;
        margin-left: 1.5rem;
    }

    @media ${MqTablet} {
        ${Monetary} {
            text-align: right;
        }

        ${Value} + ${Name} {
            margin-top: 1.75rem;
        }

        ${Name}:nth-child(5) {
            margin-top: 2.5rem;
        }
    }

    @media ${MqDesktop} {
        ${Monetary} {
            margin-right: 2rem;
        }

        ${Supply} {
            margin-left: 2rem;
        }
    }
`

export default Amounts
